/*eslint no-use-before-define: ["error", { "functions": false }]*/

import React, { Component } from 'react';
import { Route, Switch, history, BrowserRouter as Router } from 'react-router-dom';

import App from './App';
import Page1 from './components/Page1';
import Page2 from './components/Page2';
import Page3 from './components/Page3';

class AppRouter extends Component {
    render() {
        return (
            <Router>
                <div>
                    <Switch>
                        <Route exact path="/" component={App} />
                        <Route exact path="/page1" component={Page1} />
                        <Route exact path="/page2" component={Page2} />
                        <Route exact path="/page3" component={Page3} />
                    </Switch>
                </div>
            </Router>
        )
    }
}

export default AppRouter;


// WEBPACK FOOTER //
// ./src/router.jsx